import * as yup from "yup";

const contactSchema = yup.object().shape({
    namesender: yup.string().required('formcontact.name.error.required'),
    email: yup.string().email('formcontact.mail.error.regex').required('formcontact.mail.error.required'),
    message: yup.string().min(100, 'formcontact.message.error.chars').required('formcontact.message.error.required')
});

export default contactSchema;